module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jFecf"))).then(() => parcelRequire('5ok7a'));